import { IUtilsActionTypes } from "action/interfaces/utils.interface";
import { IRVehicleDetails } from "api/interfaces/garage-apis";
import { ICompactProduct } from "api/interfaces/get-page-details/common/CompactProduct.type";
import { IUrlInformation } from "api/interfaces/get-page-details/common/nested-pagecontent.type";
import { LAYOUT } from "constant/layout-constant";
import { AvailableDeliveryMethodsDetail } from "interfaces/session/ShoppingCart";

export interface IOrderCounts {
  recentOrders: number;
  pendingOrders: number;
  cancelOrders: number;
  wishList: number;
  customerSince: number | null;
  success: boolean;
  failureMessage: string;
}

export interface ISyncedProduct {
  quantity: number;
  sku: string;
}
export interface IUtilsReducer {
  width: number;
  redirectUrl: string | null,
  currentPageType: string | null,
  refeshS4: boolean,
  orderCounts: IOrderCounts | any,
  urlInformation: IUrlInformation | Record<string, never>,
  recentProducts: ICompactProduct[],
  isNewsLetterSubscriptionNeeded: boolean,
  addToCartLocation: string;
  availableDeliveryMethods: AvailableDeliveryMethodsDetail[] | null,
  previousPageType: string | null,
  syncedProduct: ISyncedProduct | null,
  vehicleDetails: Promise<object | IRVehicleDetails | []> | null,
  layout: string
  customerSupportChat: string;
  overviewId: string;
  useVehicleSelectionOptionsModal: boolean;
}

const initlaState: IUtilsReducer = {
  width: 0,
  redirectUrl: null,
  currentPageType: null,
  refeshS4: false,
  orderCounts: {},
  urlInformation: {},
  recentProducts: [],
  isNewsLetterSubscriptionNeeded: false,
  addToCartLocation: "",
  availableDeliveryMethods: null,
  previousPageType: null,
  syncedProduct: null,
  vehicleDetails: null,
  layout: LAYOUT.DETAILED,
  customerSupportChat: "",
  overviewId: "",
  useVehicleSelectionOptionsModal: false,
};

const utilsReducer = (state = initlaState, action: IUtilsActionTypes): IUtilsReducer => {
  switch (action.type) {
  case "SET_WIDTH":
    return { ...state, width: action.data };
  case "SET_PAGE_TYPE":
    return { ...state, currentPageType: action.data };
  case "REFRESH_S4":
    return { ...state, refeshS4: action.data };
  case "SET_URL_INFO":
    return { ...state, urlInformation: action.data };
  case "RECENT_PRODUCTS":
    return { ...state, recentProducts: action.data };
  case "SET_NEWS_LETTER_SUBSCRIPTION":
    return { ...state, isNewsLetterSubscriptionNeeded: action.data };
  case "ADD_TO_CART_LOCATION":
    return { ...state, addToCartLocation: action.data };
  case "SET_PRODUCT_DELIVERY_DETAILS":
    return { ...state, availableDeliveryMethods: action.data };
  case "ORDERS_COUNT":
    return { ...state, orderCounts: action.data };
  case "SET_SYNCED_PRODUCT":
    return { ...state, syncedProduct: action.data };
  case "SET_VEHICLE_DETAILS":
    return { ...state, vehicleDetails: action.data };
  case "SET_LAYOUT":
    return { ...state, layout: action.data };
  case "CHAT_TYPE":
    return { ...state, customerSupportChat: action.data };
  case "OVERVIEW_ID":
    return { ...state, overviewId: action.data };
  case "SET_USE_VEHICLE_SELECTION_MODAL":
    return { ...state, useVehicleSelectionOptionsModal: action.data };
  default:
    return state;
  }
};

export default utilsReducer;
